import { useState, useEffect, useCallback } from 'react';
import { AlertTriangle, AlertOctagon } from 'lucide-react';
import allergensData from '@/data/allergens.json';
import styles from './WarningBanner.module.css';

function checkIndexedDB(): boolean {
  try {
    return typeof indexedDB !== 'undefined' && indexedDB !== null;
  } catch {
    return false;
  }
}

export function IndexedDBBanner() {
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    setUnavailable(!checkIndexedDB());
  }, []);

  if (!unavailable) return null;

  return (
    <div className={styles.warningBanner} role="alert">
      <AlertTriangle size={16} />
      <span>Local storage unavailable — your profiles and analysis history will not be saved between sessions.</span>
    </div>
  );
}

export function LibraryLoadBanner() {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(!allergensData || (allergensData as unknown[]).length === 0);
  }, []);

  const handleRetry = useCallback(() => {
    window.location.reload();
  }, []);

  if (!failed) return null;

  return (
    <div className={styles.criticalBanner} role="alert">
      <AlertOctagon size={16} />
      <span>Critical: Allergen library failed to load. Detection is unavailable.</span>
      <button
        className={styles.retryButton}
        onClick={handleRetry}
        aria-label="Retry loading allergen library"
      >
        Retry
      </button>
    </div>
  );
}
